import React from 'react';

const LinkOutlinedL = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="m13 6.5 1.364-1.379a3 3 0 1 1 4.242 4.243l-4.243 4.243a3 3 0 0 1-4.242 0M10.999 17l-1.635 1.607a3 3 0 1 1-4.243-4.243l4.243-4.243a3 3 0 0 1 4.242 0"
            stroke="#009FDF"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);
export default LinkOutlinedL;
